import { useState, useEffect } from 'react'
import type { WritingAssistantListItem } from '../../types/writing'

export function useWritingAssistantUIStates(writingAssistants: WritingAssistantListItem[]) {
  const [minimizedStates, setMinimizedStates] = useState<Record<string, boolean>>({})
  const [manualSaveLoading, setManualSaveLoading] = useState<Record<string, boolean>>({})
  const [saveSuccess, setSaveSuccess] = useState<Record<string, boolean>>({})
  const [additionalInstructions, setAdditionalInstructions] = useState<Record<string, string>>({})

  // Initialize minimized states - only latest item expanded by default
  useEffect(() => {
    if (writingAssistants.length > 0) {
      setMinimizedStates(prev => {
        const newStates = { ...prev }
        // Find the most recent writing assistant by createdAt
        const latestWA = writingAssistants.reduce((latest, current) =>
          new Date(current.createdAt) > new Date(latest.createdAt) ? current : latest
        )
        writingAssistants.forEach(wa => {
          // Only expand the latest item on initial load
          if (newStates[wa.id] === undefined) {
            newStates[wa.id] = wa.id !== latestWA.id
          }
        })
        return newStates
      })
    }
  }, [writingAssistants])

  const toggleMinimized = (writingAssistantId: string) => {
    setMinimizedStates(prev => ({
      ...prev,
      [writingAssistantId]: !prev[writingAssistantId],
    }))
  }

  const showSaveSuccess = (writingAssistantId: string) => {
    setSaveSuccess(prev => ({ ...prev, [writingAssistantId]: true }))
    setTimeout(() => {
      setSaveSuccess(prev => ({ ...prev, [writingAssistantId]: false }))
    }, 3000)
  }

  return {
    minimizedStates,
    toggleMinimized,
    manualSaveLoading,
    setManualSaveLoading,
    saveSuccess,
    showSaveSuccess,
    additionalInstructions,
    setAdditionalInstructions,
  }
}
